import { Injectable, InjectionToken, Inject } from '@angular/core';
import Rollbar from 'rollbar';

const rollbarConfig = {
  accessToken: '7ebfc47a82694573a861df4480303547',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: 'production',
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) {}

  log(message: string, extra?: any) {
    this.rollbar.log(message, extra);
  }

  error(error: any, extra?: any) {
    this.rollbar.error(error, extra);
  }

  info(message: string, extra?: any) {
    this.rollbar.info(message, extra);
  }

  warn(message: string, extra?: any) {
    this.rollbar.warn(message, extra);
  }

  debug(message: string, extra?: any) {
    this.rollbar.debug(message, extra);
  }

  critical(error: any, extra?: any) {
    this.rollbar.critical(error, extra);
  }
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}
